import { useTranslation } from 'react-i18next';

import { DeviceType } from 'clipsal-cortex-types/src/api';

import { HardwareConnectionType } from './types';

export function useDeviceSubtitle() {
  const { t } = useTranslation();

  const getSubtitle = (device?: DeviceType, enabled?: boolean, connection?: HardwareConnectionType) =>
    connection
      ? `${t('Hardware.subtitle', {
          device: t(`Hardware.deviceType.${device ?? 'UNKNOWN'}`),
          enabled: enabled ? t('Hardware.connection enabled') : t('Hardware.connection disabled'),
          connection: t(`Hardware.connectionKey.${connection ?? 'DISABLED'}`),
        })}        `
      : undefined;

  return { getSubtitle };
}
